import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import global_ru from './translations/ru/global.json'
import global_ro from './translations/ro/global.json'

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    detection: {
      lookupQuerystring: 'lng',
    },
    resources: {
      ru: {
        global: global_ru,
      },
      ro: {
        global: global_ro,
      },
    },
    fallbackLng: 'ro',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18next
